import { render, staticRenderFns } from "./ProjectBrandManagement.vue?vue&type=template&id=5da7295f&scoped=true&"
import script from "./ProjectBrandManagement.vue?vue&type=script&lang=js&"
export * from "./ProjectBrandManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBrandManagement.vue?vue&type=style&index=0&id=5da7295f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da7295f",
  null
  
)

export default component.exports